<template>
	<el-container :style="'height: '+$store.state.height+'px'">
		<el-aside :width="menuwidth">
			<el-row>
				<el-col :span="24">
					<div class="head-logo" @click="$store.state.main.user.m_qaedas_id==0?$router.push('/main'):''">
						<div class="logo-img-div">
							<img :src="$store.state.main.qaedas==null?require('../../assets/logo.png'):(this.config.apiurl + $store.state.main.qaedas.image)"
							 alt="" class="logo-img">
						</div>
						<div class="logo-img-title" v-show="!isOpen">
							{{$store.state.main.qaedas==null?'智慧农业云平台':$store.state.main.qaedas.name}}
						</div>
					</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<div class="mune-main">主菜单</div>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
					<el-menu :collapse="isOpen" :default-active="menuIndex" background-color="#222d32" text-color="#b8c7ce"
					 active-text-color="white" router>
						<el-menu-item v-for="(item,index) in menu" @click="openmune($store.state.width<$store.state.minwidth)" :index="item.link"
						 :key="index" v-bind:class="{ menuselect: menuIndex==item.link}">
							<i :class="item.icon"></i>
							<span slot="title">{{item.name}}</span>
						</el-menu-item>
					</el-menu>
				</el-col>
			</el-row>
			<el-row v-show="!isOpen">
				<el-col :span="24">
					<div class="mune-about">相关链接</div>
				</el-col>
			</el-row>
			<el-row v-show="!isOpen">
				<el-col :span="24" v-show="$store.state.main.qaedas.lot_system==1">
					<div class="mune-about-url" @click="moveto('/iot/terminal')"><i class="my-icon-iot"></i>物联系统</div>
				</el-col>
				<el-col :span="24" v-show="$store.state.main.qaedas.video_system==1">
					<div class="mune-about-url" @click="moveto('/video/show')"><i class="my-icon-jkgl"></i>视频监控</div>
				</el-col>
				<el-col :span="24" v-show="$store.state.main.qaedas.production_system==1">
					<div class="mune-about-url" @click="moveto('/production/record')"><i class="my-icon-shc"></i>生产信息</div>
				</el-col>
				<el-col :span="24" v-show="$store.state.main.user.m_qaedas_id==0">
					<div class="mune-about-url" @click="moveto('/main')"><i class="my-icon-jidi"></i>基地管理</div>
				</el-col>
				<el-col :span="24" v-if="$store.state.main.user.isAlarm==2">
					<div class="mune-about-url" @click="moveto('/warning')"><i class="my-icon-yujing"></i>设备预警</div>
				</el-col>
			</el-row>
		</el-aside>
		<el-container>
			<el-header height="50px">
				<el-row>
					<el-col :span="4" class="header-left">
						<el-button icon="my-icon-menu" class="menu-button" @click="openmune(true)"></el-button>
					</el-col>
					<el-col :span="16" class="header-center">
						<span v-if="$store.state.width<$store.state.minwidth">{{$store.state.main.qaedas==null?'智慧农业云平台':$store.state.main.qaedas.name}}</span>
						<span v-else>&nbsp;</span>
					</el-col>
					<el-col :span="4" class="header-right">
						<el-dropdown @command="userclick">
							<div class="header-user-div">
								<img :src="$store.state.main.user==null?require('../../assets/logo.png'):(this.config.apiurl + $store.state.main.user.avatar)"
								 alt="" class="header-user-img">
								<br />
								<span>{{$store.state.main.user==null?"admin":$store.state.main.user.nickname}}</span>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="set"><i class="iconfont icon-gerenpeizhi"></i>个人配置</el-dropdown-item>
								<el-dropdown-item command="out"><i class="iconfont icon-web-icon-"></i>退出登录</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</el-col>
				</el-row>
			</el-header>
			<el-main v-loading="$store.state.mainload" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
			 element-loading-background="rgba(0, 0, 0, 0.8)">
				<div class="div-main" :style="'height: '+($store.state.height-80-($store.state.isphone?10:40))+'px;'">
					<router-view />
				</div>
			</el-main>
			<el-footer height="30px">
				<el-row>
					<el-col :span="6" v-show="$store.state.width>$store.state.minwidth" class="footer-left">{{$store.state.main.qaedas==null?'智慧农业云平台':$store.state.main.qaedas.name}}</el-col>
					<el-col :span="12 + ($store.state.width>$store.state.minwidth?0:12)" class="footer-center">
						<a class="link" href="http://www.farmereasy.com/" target="view_window">{{$store.state.main.user.associates||"成都市易农科技有限公司"}}</a>&nbsp;
						<a class="link" href="http://beian.miit.gov.cn/" target="_blank">蜀ICP备16005725号</a>
					</el-col>
					<el-col :span="6" v-show="$store.state.width>$store.state.minwidth" class="footer-right">{{time}}</el-col>
				</el-row>
			</el-footer>
		</el-container>
	</el-container>
</template>

<script>
	export default {
		data() {
			return {
				menuwidth: "250px",
				isOpen: false,
				menuIndex: "retrospect",
				time: null,
				menu: [{
						id: "1",
						name: "溯源记录",
						icon: "my-icon-syjl",
						link: "retrospect",
						select: true,
						submenu: []
					},
					// {
					// 	id:"2",
					// 	name:"物种结档",
					// 	icon:"my-icon-guidang",
					// 	link:"settle",
					// 	select: false,
					// 	submenu: []
					// }
				]
			};
		},
		watch: {
			$route: {
				handler: function(val, oldVal) {
					var select = val.path;
					select = select.split('/')[select.split('/').length - 1];
					this.menuIndex = select;
				},
				// 深度观察监听
				deep: true
			}
		},
		methods: {
			load() {
				this.menuselect();
				this.getuser();
				this.getqaedas({
					id: this.getCookie(this.config.jdid)
				});
				this.nowtime();
			},
			getHeight() {
				let body = document.getElementsByTagName("body");
				if (this.$store.state.width < this.$store.state.minwidth) {
					this.menuwidth = "0px";
					this.isOpen = true;
					body[0].style.width = "";
				} else {
					this.menuwidth = "250px";
					this.isOpen = false;
					body[0].style.width = "";
				}
			},
			openmune(sub) {
				if (sub) {
					this.isOpen = !this.isOpen;
					let wid = this.isOpen ? 64 : 250;
					let body = document.getElementsByTagName("body");
					if (this.isOpen && this.$store.state.width < this.$store.state.minwidth) {
						wid -= 64;
						body[0].style.width = "";
					}
					if (!this.isOpen && this.$store.state.width < this.$store.state.minwidth) {
						body[0].style.width = this.$store.state.width + 16 + 250 + "px";
					}
					this.menuwidth = wid + "px";
				}
			},
			menuselect() {
				let url = this.$route.path;
				let select = url.split('/')[url.split('/').length - 1];
				this.menuIndex = select;
			},
			nowtime() {
				let _this = this;
				this.timer = setInterval(() => {
					_this.time = this.Totime(new Date().getTime() / 1000);
				}, 1000)
			},
			moveto(value) {
				this.$router.push({
					path: value
				});
			},
			userclick(command) {
				if (command == 'out') {
					this.logoutM();
				}
				if (command == 'set') {
					this.$router.push("userset");
				}
			}
		},
		mounted: function() {
			this.load();
		},
		created() {
			window.addEventListener('resize', this.getHeight);
			this.getHeight()
		},
		destroyed() {
			window.removeEventListener('resize', this.getHeight)
		}
	}
</script>

<style scoped>
	.el-header,
	.el-footer {
		background-color: #18bc9c;
	}

	.el-aside {
		background-color: #222d32;
	}

	.el-main {
		background-color: #f0f0f0;
		overflow-y: hidden;
		padding: 0px;
	}

	.div-main {
		padding: 20px;
		overflow-y: auto;
	}

	.head-logo {
		background-color: #15a589;
		cursor: pointer;
	}

	.menuselect {
		background-color: #18bc9c !important;
		text-color: white;
	}

	.el-header {
		padding: 0px;
	}

	.el-footer,
	.el-main,
	.el-aside,
	.el-header {
		overflow-x: hidden;
	}

	.el-footer,
	.el-header {
		overflow-y: hidden;
	}

	.el-aside {
		transition: width 0.5s;
	}

	.head-logo {
		height: 50px;
		cursor: pointer;
	}

	.logo-img {
		width: 44px;
		height: 44px;
		border-radius: 50%;
		margin: 3px;
	}

	.logo-img-title {
		float: left;
		width: auto;
		line-height: 50px;
	}

	.logo-img-div {
		float: left;
		width: 60px;
		height: 50px;
		text-align: center;
	}

	.el-menu {
		border-right: 0px;
	}

	.menu-button {
		border-radius: 0px;
		height: 50px;
		border: 0px;
		padding: 12px 15px;
		background-color: #099076;
		color: white;
	}

	.menu-button:hover,
	.menu-button:focus {
		background-color: #667976 !important;
		color: white;
	}

	.mune-main {
		/* background-color: #42B983;
		padding: 8px 5px; */
		background-color: #7C7F86;
		padding: 8px 5px;
		color: white;
		font-weight: 800;
	}

	.mune-about {
		/* background-color: #7C7F86; */
		background-color: #7C7F86;
		padding: 8px 5px;
		color: white;
		font-size: 14px;
	}

	.mune-about-url {
		background-color: #222d32;
		/* #CCCCCC; */
		padding: 6px 0px;
		padding-left: 30px;
		color: #b8c7ce;
		/* border-bottom: 1px solid #A9A9A9; */
		cursor: pointer;
		font-size: 13px;
	}

	.mune-about-url:hover {
		background-color: #36383e;
		color: white;
	}

	.header-left {}

	.header-center {
		text-align: center;
		line-height: 50px;
		font-size: 20px;
	}

	.header-right {
		text-align: right;
	}

	.header-user-div {
		width: 90px;
		height: 50px;
		float: right;
		text-align: center;
		font-size: 12px;
		cursor: pointer;
	}

	.header-user-img {
		width: 30px;
		height: 30px;
		border-radius: 50%;
		background-color: white;
	}

	.footer-left,
	.footer-center,
	.footer-right {
		line-height: 30px;
	}

	.footer-center {
		text-align: center;
	}

	.footer-right {
		text-align: right;
	}

	.link {
		text-decoration: none;
		color: black;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.div-main {
			padding: 5px 0px;
		}

		.link {
			font-size: 12px;
		}
	}
</style>
